var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 64,
    viewBox: "0 0 120 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaGradient",
    x1: 0,
    y1: 0,
    x2: 120,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3c6fc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "adaGlow",
    cx: 60,
    cy: 32,
    r: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0f7fa",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3c6fc",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "adaShadow",
    x: -10,
    y: -10,
    width: 140,
    height: 84,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#29b6f6",
    floodOpacity: 0.18
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 54,
    rx: 18,
    ry: 8,
    fill: "url(#adaGlow)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 10,
    rx: 22,
    ry: 10,
    fill: "url(#adaGlow)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 54,
    rx: 10,
    ry: 4,
    fill: "url(#adaGlow)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 10,
    rx: 10,
    ry: 4,
    fill: "url(#adaGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#adaShadow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 48,
    fontFamily: "Segoe UI, Inter, Arial, sans-serif",
    fontSize: 44,
    fontWeight: "bold",
    fill: "url(#adaGradient)",
    letterSpacing: 2
  }, "ADA"), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 4,
    fill: "#26c6da",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36,
    r: 2.5,
    fill: "#039be5",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 28,
    r: 3,
    fill: "#039be5",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#b3c6fc",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 30,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#b3c6fc",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#b3c6fc",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaLogo);
export default __webpack_public_path__ + "static/media/ada-logo.599cc20a3325af02f09aa3ef0d539b76.svg";
export { ForwardRef as ReactComponent };